import { Button } from "../button/Button";
import { HelpCircle } from "lucide-react";
import Input from "../form/Input";
import Avatar from "../avatar/Avatar";
import NotificationBell from "./NotificationBell";
import { useState } from "react";
import { useAuth } from "@/auth/AuthContext";

const Header: React.FC = () => {
  const { user } = useAuth();
  const [keySearch, setKeySearch] = useState("");
  return (
    <div className="bg-card h-full w-full flex items-center justify-between pr-6">
      <div className=" w-2/3">
        <Input
          value={keySearch}
          onChange={(e) => setKeySearch(e.target.value)}
          type="search"
          placeholder="Rechercher"
        />
      </div>
      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="icon-lg"
          className="relative rounded-full border-0  font-semibold text-2xl"
        >
          <HelpCircle className="w-6! h-6!" />
        </Button>
        <NotificationBell />
        <div className="flex items-center gap-2">
          <Avatar user={user} />
          <div className="flex flex-col items-start gap-1">
            <span className="font-medium leading-none capitalize text-base">
              {user?.firstName}
            </span>
            <span className="text-xs text-slate-500 leading-none text-muted-foreground">
              {user?.role}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
